import { render, staticRenderFns } from "./PdfEmbed.vue?vue&type=template&id=9a809be4&scoped=true&"
import script from "./PdfEmbed.vue?vue&type=script&lang=js&"
export * from "./PdfEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PdfEmbed.vue?vue&type=style&index=0&id=9a809be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a809be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
